module.exports = "/_next/static/images/08-bfe41dddfb960cfb53101b6114304915.png";